module.exports = __webpack_public_path__ + "img/dc1ce34.jpg";